import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../../../../-LazyRoutePage"

const ProcurementRequestPage = lazy(
  () =>
    import(
      "../../../../../components/WMS/ProcurementRequests/ProcurementRequestPage"
    ),
)

export const Route = createFileRoute("/_layout/WMS/documents/zap/$zap")({
  validateSearch: (search: Record<string, unknown>) => ({
    tab:
      search.tab === "general"
        ? "general"
        : search.tab === "info"
          ? "info"
          : search.tab === "files"
            ? "files"
            : undefined,
    edit:
      search.edit === 1 || search.edit === "1" || search.edit === true
        ? 1
        : undefined,
  }),
  component: ProcurementRequestRoute,
})

function ProcurementRequestRoute() {
  return (
    <LazyRoutePage>
      <ProcurementRequestPage />
    </LazyRoutePage>
  )
}
